import request from '@/utils/request'

// 供应商下拉
export const getSupplierList = (data) => {
  return request({
    url: `/wms-web/basSupplier/list`,
    method: 'post',
    data
  })
}

// 新增/修改供应商
export const saveOrUpdate = (data) => {
  return request({
    url: `/wms-web/basSupplier/saveOrUpdate`,
    method: 'post',
    data
  })
}

// 添加SKU
export const supplierSaveSku = (data) => {
  return request({
    url: `/wms-web/basSupplier/saveSku`,
    method: 'post',
    data
  })
}

// 删除SKU
export const supplierDelSku = (data) => {
  return request({
    url: `/wms-web/basSupplier/delSku`,
    method: 'post',
    data
  })
}

// 产品组检查供应商是否已存在产品组
export const checkSupplier = (data) => {
  return request({
    url: `/wms-web/bas/sku/group/checkSupplier`,
    method: 'post',
    data
  })
}

//改菜单
export const saveMenuApi = (data) => {
  return request({
    url: `/wms-web/menuSupplierConfig/updateMenuSupplierConfig`,
    method: 'post',
    data
  })
}

//改菜单-小程序
export const updateMenuSupplierConfig = (data) => {
  return request({
    url: `/wms-web/menuAppletConfig/updateMenuSupplierConfig`,
    method: 'post',
    data
  })
}

// 上传资质报告
export function saveQualificationReport(data) {
  return request({
    url: `/wms-web/qualification/report/uploadReport` ,
    method: 'post',
    data
  })
}

// 移除报告
export function removeQualificationReport(data) {
  return request({
    url: `/wms-web/qualification/report/delReport` ,
    method: 'post',
    data
  })
}

// 审核
export function examineQualificationReport(data) {
  return request({
    url: `/wms-web/qualification/report/examineReport` ,
    method: 'post',
    data
  })
}

// 作废报告
export function cancelQualificationReport(data) {
  return request({
    url: `/wms-web/qualification/report/nullifyReport` ,
    method: 'post',
    data
  })
}

// 查看报告
export function findFileQualificationReport(data) {
  return request({
    url: `/wms-web/qualification/report/findFile` ,
    method: 'post',
    data
  })
}

//供拣供应商
export function getSupplierGj(data) {
  return request({
    url: `/wms-web/basSupplier/gj/list` ,
    method: 'post',
    data
  })
}

// 供应商可供货sku修改备库采购单位和采拣换算率
export function updateRowDataApi(data) {
  return request({
    url: `/wms-web/basSupplier/updatePurchaseUnit` ,
    method: 'post',
    data
  })
}

// WEB权限是否可用开关
export function menuSupplierConfigUpdateEnable(data) {
  return request({
    url: `/wms-web/menuSupplierConfig/updateEnable` ,
    method: 'post',
    data
  })
}

// 小程序权限是否可用开关
export function menuAppletConfigUpdateEnable(data) {
  return request({
    url: `/wms-web/menuAppletConfig/updateEnable` ,
    method: 'post',
    data
  })
}


// 供应商标签
export function getSupplierLabelApi(data) {
  return request({
    url: `/wms-web/sys/select/listNew`,
    method: 'post',
    data
  })
}

//供应商标签新增/删除
export function saveOrDelSupplierLabel(data) {
  return request({
    url: `/wms-web/sys/select/saveAll`,
    method: 'post',
    data
  })
}

// 下拉列表更新排序
export function selectListUpdateSort(data) {
  return request({
    url: `/wms-web/sys/select/updateSort`,
    method: 'post',
    data
  })
}

// 文件压缩下载
export function reportGetFileZip(data) {
  return request({
    url: `/wms-web/qualification/report/getFileZip`,
    method: 'post',
    data,
    responseType: 'arraybuffer',
    hasName: true
  })
}

//可供货SKU清单中有时价货的供应商
export function getDynamicPriceSupplierListApi(data) {
  return request({
    url: `/wms-web/basSupplier/dynamicPriceSupplierList`,
    method: 'post',
    data,
  })
}
//查询列表统计信息

export function getStatisticsApi(data) {
  return request({
    url: `/wms-web/basSupplier/pages/statistics`,
    method: 'post',
    data,
  })
}

//删除供应商用户
export function delUser(id) {
  return request({
    url: `/wms-web/sys/user/delete/${id}`,
    method: 'post',
  })
}

//查询供应商自主web全部菜单
export function getMenuSupplierListApi(data) {
  return request({
    url: `/wms-web/menuSupplierConfig/page/1/500`,
    method: 'post',
    data
  })
}

//批量修改供应商自主web权限菜单
export function batchUpdateSupplierApi(data) {
  return request({
    url: `/wms-web/menuSupplierConfig/batch/updateEnable`,
    method: 'post',
    data
  })
}

//查询供应商app全部菜单
export function getMenuAppletListApi(data) {
  return request({
    url: `/wms-web/menuAppletConfig/page/1/500`,
    method: 'post',
    data
  })
}

//批量修改供应商app权限菜单
export function batchUpdateAppletApi(data) {
  return request({
    url: `/wms-web/menuAppletConfig/batch/updateEnable`,
    method: 'post',
    data
  })
}


//删除指定外采例外表格row
export function delBasSupplierSpecifiedPurchaseSkuExceptionApi(data) {
  return request({
    url: `/wms-web//basSupplierSpecifiedPurchaseSkuException/delete`,
    method: 'post',
    data
  })
}

//查询工商信息
export function getQueryBusinessInfo(data) {
  return request({
    url: `/wms-web/basSupplier/queryBusinessInfo`,
    method: 'post',
    data
  })
}

//修改工商信息
export function updateBusinessInfo(data) {
  return request({
    url: `/wms-web/basSupplier/queryBusinessInfo`,
    method: 'post',
    data
  })
}
